import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFilmCamera$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFilmCamera extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '439c0761f9568e12f8158d0f51c5f93820943109', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '18bddd5b93479056a2d129949bcd256b2bd0b2d8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '620c9e732a2f6fa2231f36343210b8267edd12cc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.5 9c-1.2 0-2.3-.6-2.9-1.5C8.1 8.4 7.1 9 6 9 4.3 9 3 7.7 3 6s1.3-3 3-3c.9 0 1.7.4 2.3 1.1.5-1.2 1.8-2.1 3.2-2.1C13.4 2 15 3.6 15 5.5S13.4 9 11.5 9m0 0h3c.3 0 .5.2.5.5v1.8l2.3-1.2c.3-.2.7 0 .7.4v5.9c0 .4-.4.7-.7.5L15 15.7v1.8c0 .3-.2.5-.5.5h-11c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5zm2-3.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2M6 7.7c-.9 0-1.7-.8-1.7-1.7S5.1 4.3 6 4.3s1.7.8 1.7 1.7S6.9 7.7 6 7.7m7.5 8.8h-9v-6h9z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-film-camera", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-film-camera"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-film-camera":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFilmCamera$1);
            }
            break;
    } });
}

const CosmosIconFilmCamera = CosmosIconFilmCamera$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFilmCamera, defineCustomElement };
